import React from 'react';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import AccordionOneColumn from '../AccordionOneColumn';
import type { AccordionOneColumnProps } from '../AccordionOneColumn/AccordionsOneColumn';

type AccordionsTwoColumnsProps = Pick<
  AccordionOneColumnProps,
  | 'firstQuestionId'
  | 'baseURL'
  | 'noAnimation'
  | 'openOneAnswer'
  | 'suppressInitialOpenAnimation'
  | 'layout_type'
  | 'itemAppearance'
  | 'openQuestionIcon'
  | 'questionFontParam'
> & {
  filteredQuestions: QuestionEntry[];
};

const AccordionsTwoColumns = ({
  filteredQuestions,
  firstQuestionId,
  baseURL,
  noAnimation,
  openOneAnswer,
  suppressInitialOpenAnimation,
  layout_type,
  itemAppearance,
  openQuestionIcon,
  questionFontParam,
}: AccordionsTwoColumnsProps) => {
  const leftQuestions = filteredQuestions.filter(
    (item, index) => index % 2 === 0,
  );
  const rightQuestions = filteredQuestions.filter(
    (item, index) => index % 2 === 1,
  );
  const accordionProps = {
    firstQuestionId,
    baseURL,
    noAnimation,
    openOneAnswer,
    suppressInitialOpenAnimation,
    layout_type,
    itemAppearance,
    openQuestionIcon,
    questionFontParam,
  };
  return (
    <>
      <AccordionOneColumn
        filteredQuestions={leftQuestions}
        {...accordionProps}
      />
      <AccordionOneColumn
        filteredQuestions={rightQuestions}
        {...accordionProps}
      />
    </>
  );
};

export default AccordionsTwoColumns;
